/** 실행 기록 알림 — 말과 판정은 runHistoryNoticeView.ts 정본 */
import { Typography, type TypographyProps } from '@mui/material';
import { RUN_HISTORY_NOTICE, type RunHistoryNoticeState } from './runHistoryNoticeView';

export function RunHistoryNotice({ state, sx = { py: 2 } }: { state: RunHistoryNoticeState; sx?: TypographyProps['sx'] }) {
  const view = RUN_HISTORY_NOTICE[state];
  return (
    <Typography variant="body2" color={view.color} sx={sx} role="status" data-state={state}>
      {view.text}
    </Typography>
  );
}
